<template>
  <b-form @submit.prevent>
    <b-form-row>
      <b-form-group label="Imię" class="mr-3">
        <b-form-input v-model="filters.firstName" type="text" autocomplete="off" />
      </b-form-group>

      <b-form-group label="Nazwisko" class="mr-3">
        <b-form-input v-model="filters.lastName" type="text" autocomplete="off" />
      </b-form-group>

      <b-form-group label="Email" class="mr-3">
        <b-form-input v-model="filters.email" type="text" autocomplete="off" />
      </b-form-group>

      <b-form-group label="Konto aktywne" class="mr-3">
        <b-form-select v-model="filters.isActive" :options="isActiveOptions"></b-form-select>
      </b-form-group>

      <b-form-group class="mt-auto">
        <b-button type="submit" class="mr-3" variant="primary" @click="onSearch">Szukaj</b-button>
        <b-button type="submit" class="mr-3" variant="secondary" @click="clear">Wyczyść</b-button>
      </b-form-group>
    </b-form-row>
  </b-form>
</template>
<script>
export default {
  data() {
    return {
      filters: {
        firstName: null,
        lastName: null,
        email: null,
        isActive: null
      },
      isActiveOptions: [
        { text: "", value: null },
        { text: "Tak", value: true },
        { text: "Nie", value: false }
      ]
    };
  },
  methods: {
    clear() {
      this.filters.firstName = null;
      this.filters.lastName = null;
      this.filters.email = null;
      this.filters.isActive = null;
    },
    onSearch() {
      this.$emit("filters-search", this.filters);
    }
  }
};
</script>
<style lang="scss" scoped>
</style>
